import { Feature, FeatureFlagService } from '@treasury/domain/services/feature-flags';

InternalTransfersEntitlementsController.$inject = [
    '$scope',
    '$window',
    '$filter',
    'usersService',
    'toaster',
    'securityService',
];

export default function InternalTransfersEntitlementsController(
    $scope,
    $window,
    $filter,
    usersService,
    toaster,
    securityService
) {
    $scope.isSuperUser = $scope.$parent.userHeader.isSuperUser;
    $scope.columnValues = [];
    $scope.searchText = '';
    $scope.entitlements = {};
    $scope.entitlementsPristine = {};
    $scope.filteredEntitlements = {};

    $scope.setForm = setForm;
    $scope.reset = reset;
    $scope.save = save;
    $scope.toggleAll = toggleAll;
    $scope.toggleColumn = toggleColumn;
    $scope.toggleEntitlement = toggleEntitlement;
    $scope.toggleRow = toggleRow;
    $scope.updateColumnToggle = updateColumnToggle;
    $scope.search = search;
    $scope.showSuperUserPanel = false;

    async function init() {
        loadEntitlements();

        [$scope.hasAccountNumberEntitlementView, $scope.showSuperUserPanel] = await Promise.all([
            FeatureFlagService.isEnabled(Feature.ChannelUseAccountNameTM6777),
            FeatureFlagService.isEnabled(Feature.AccountSuperUserEntitlements).then(ff => {
                return !ff && $scope.isSuperUser;
            }),
        ]);
    }

    function setForm(form) {
        $scope.form = form;
    }

    function save() {
        const updates = usersService.buildUpdateProductEntitlementsRequest(
            $scope.entitlements,
            $scope.entitlementsPristine
        );

        securityService
            .verifyUser('Edit User', updates, () =>
                usersService.updateProductEntitlements($scope.id, updates)
            )
            .then(response => {
                if (response.success) {
                    $scope.entitlementsPristine = $window.angular.copy($scope.entitlements);
                    $scope.$parent.notifySave();
                    $scope.form.$setPristine();
                    toaster.save('Internal Transfer Entitlements');
                }
            });
    }

    function reset() {
        $scope.entitlements = $window.angular.copy($scope.entitlementsPristine);
        $scope.form.$setPristine();
        updateFilteredEntitlements($scope.searchText);
    }

    function search(searchText) {
        $scope.searchText = searchText;
        if ($scope.entitlements) {
            updateFilteredEntitlements(searchText);
        }
    }

    // toggle events

    function updateAllColumnToggles() {
        for (let i = 0; i < $scope.columnValues.length; i++) {
            updateColumnToggle(i);
        }
    }

    function toggleEntitlement() {
        let currentValue = true;
        const { userProductClaims } = $scope.entitlements;
        $window.angular.forEach(userProductClaims, claim => {
            if (!claim.hasPendingUserClaim) {
                currentValue = false;
            }
        });

        $window.angular.forEach(userProductClaims, claim => {
            claim.hasPendingUserClaim = !currentValue;
        });

        $scope.form.$setDirty();
    }

    function toggleAll() {
        let currentValue = true;
        const accounts = $scope.filteredEntitlements;

        // Find current value.
        $window.angular.forEach(accounts, account => {
            const { userAccountClaims } = account;
            $window.angular.forEach(userAccountClaims, claim => {
                if (!claim.hasPendingUserClaim) {
                    currentValue = false;
                }
            });
        });

        // Set all values to opposite of current value.
        $window.angular.forEach(accounts, accountEntitlement => {
            const { userAccountClaims } = accountEntitlement;
            $window.angular.forEach(userAccountClaims, claim => {
                claim.hasPendingUserClaim = !currentValue;
            });
        });

        // Update column header toggles.
        for (let i = 0; i < $scope.columnValues.length; i++) {
            $scope.columnValues[i] = !currentValue;
        }

        $scope.form.$setDirty();
    }

    function toggleRow(entitlement) {
        let currentValue = true;
        const { userAccountClaims } = entitlement;

        // Find current value.
        $window.angular.forEach(userAccountClaims, claim => {
            if (!claim.hasPendingUserClaim) {
                currentValue = false;
            }
        });

        // Set all values to opposite of current value.
        $window.angular.forEach(userAccountClaims, claim => {
            claim.hasPendingUserClaim = !currentValue;
        });

        updateAllColumnToggles();
        $scope.form.$setDirty();
    }

    function toggleColumn(value, permissionIndex) {
        const accounts = $scope.filteredEntitlements;
        $window.angular.forEach(accounts, account => {
            account.userAccountClaims[permissionIndex].hasPendingUserClaim = value;
        });
        $scope.form.$setDirty();
    }

    function updateColumnToggle(index) {
        let result = true;
        const accounts = $scope.filteredEntitlements;
        $window.angular.forEach(accounts, account => {
            if (!account.userAccountClaims[index].hasPendingUserClaim) {
                result = false;
            }
        });
        $scope.columnValues[index] = result;
    }

    // Private
    function loadEntitlements() {
        usersService.getProductEntitlements($scope.id, 'InternalTransfer').then(response => {
            $scope.entitlements = response;
            if (response.accountProductClaims) {
                for (let i = 0; i < response.accountProductClaims.length; i++) {
                    $scope.columnValues.push(false);
                }
            }
            $scope.entitlementsPristine = $window.angular.copy($scope.entitlements);
            updateFilteredEntitlements('');
        });
    }

    function updateFilteredEntitlements(searchText) {
        const allEntitlements = $scope.entitlements.accounts;
        searchText = searchText || '';
        $scope.filteredEntitlements = $filter('filter')(allEntitlements, searchText);
        updateAllColumnToggles();
    }

    init();
}
